__webpack_require__.p = "https://cdn.xsolla.net/xsolla-babka/v-20261008-01/";